/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const TableVerified: React.FC<Props> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.3281 2.5C18.1909 2.5 18.7451 3.25712 18.7451 4V15.9932C18.7451 16.736 18.1908 17.4932 17.3281 17.4932H2.66602C1.80357 17.4929 1.25007 16.7359 1.25 15.9932V4C1.25 3.25725 1.80351 2.50026 2.66602 2.5H17.3281ZM2.75 12.9951V15.9932H6.58203V12.9951H2.75ZM8.08203 12.9951V15.9932H11.9102V12.9951H8.08203ZM13.4102 12.9951V15.9932H17.2451V12.9951H13.4102ZM2.75 11.4951H6.58203V8.49707H2.75V11.4951ZM8.08203 11.4951H11.9102V8.49707H8.08203V11.4951ZM13.4102 11.4951H17.2451V8.49707H13.4102V11.4951ZM2.75 6.99707H6.58203V4H2.75V6.99707ZM8.08203 6.99707H11.9102V4H8.08203V6.99707ZM13.4102 6.99707H17.2451V4H13.4102V6.99707Z"
      fill={color ?? props?.style?.color}
    />
  </svg>
);

export default TableVerified;
